import { render, staticRenderFns } from "./TractVisitAttachments.vue?vue&type=template&id=2c4dbb4a&"
import script from "./TractVisitAttachments.vue?vue&type=script&lang=js&"
export * from "./TractVisitAttachments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports